import type { FieldConfig } from '@/types'

export const formatInlineDescription = (
  description: FieldConfig['description'],
): string[] => {
  if (typeof description === 'string') {
    return description
      .split('\n')
      .filter(item => item.trim().startsWith('- '))
      .map(item => item.replace('- ', ''))
  } else if (Array.isArray(description)) {
    // Handle array of strings or objects
    return description.map(item => (typeof item === 'string' ? item : item.text))
  }
  return []
}
